import {Col, Input, Row, Select, Timeline} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { t } from 'i18next';
import React from 'react';
import PrimaryButton from '../../../../component/button/PrimaryButton';
import SecondaryButton from '../../../../component/button/SecondaryButton';
import ModalSuccessUpdated from '../../../../component/modal/ModalSuccessUpdated';
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import HeaderPages from '../../../../component/page-components/pages-header';
import useEditTemperature from './edit-temperature.hooks';
import NotifFailedSaved from '../../../../component/modal/NotifFailedSaved';
import { ROUTES } from '../../../../constant/routeConstant';
import ModalConfirmLeave from '../../../../component/modal/ModalConfirmLeave';
import {ActiveDotIcon, BackIcon, CloseIcon, InactiveDotIcon} from "../../../../asset";

const EditTemperature = () => {
  const {
    handleBack,
    data,
    name,
    code,
    desc,
    list,
    visible,
    _onChange,
    _onSave,
    handleOk,
    error,
    err,
    failedModalOpen,
    messageFailed,
    setFailedModalOpen,
    showConfirm,
    setShowConfirm,
    convertTimestamp,
    convertToTime,
    userManagementOpen,
    setUserManagementOpen,
    managementHistoryList
  } = useEditTemperature();

  return (
    <>
      <div className='p-5 h-fit'>

        <ModalConfirmLeave
          visible={showConfirm}
          action={() => setShowConfirm(false)}
          route={ROUTES.TEMPERATURE_CATEGORY.LIST}
        />

        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Temperature Category`}
          menuLevel4={`Edit Temperature Category `}
        />
        <div className='flex items-center justify-between my-[31px]' >
          <div className="flex items-center gap-[22px] cursor-pointer" onClick={() => handleBack()}>
            <img src={BackIcon} alt="" />
            <h1 className='font-sans-bold text-2xl' id='title'>{`Edit Temperature Category ${data?.name} - ${data?.code_name}`}</h1>
          </div>

          <div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
            <p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{data?.created_by_name}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(data?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{data?.updated_by_name}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(data?.updated_at, true)}</strong></p>
          </div>
        </div>

        <aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
          <button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
            <img src={CloseIcon} alt="" />
          </button>

          <h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
          <p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{data?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(data?.created_at)}</strong></p>


          <div>
            <Timeline>
              {
                managementHistoryList.map((item, index) => {
                  if (index === 0) {
                    return (
                        <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                          <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                            <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
                            <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                            <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                          </div>
                        </Timeline.Item>
                    )
                  } else {
                    return (
                        <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                          <div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
                            <h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
                            <h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
                            <p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
                          </div>
                        </Timeline.Item>
                    )
                  }
                })
              }
            </Timeline>
          </div>
        </aside>

        <div className=' bg-white-100 p-5 rounded-[10px] h-96'>
          <p className=' font-roboto text-lg text-black-100 font-bold'>
            Detail to Add Temperature Category
          </p>
          <Row className='mt-5'>
            <Col span={12}>
              <div>
                <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                  {t("Category Name")}
                </p>
                <Input
                  style={{ width: '50%' }}
                  size='large'
                  value={name}
                  onChange={(event) => { _onChange(event, 'name') }}
                  placeholder={t("COMMON:TYPE", { field: t("Category Name") })}
                  status={error?.name ? 'error' : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.name}
              </div>
              <div>
                <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                  {t("Temperature Code")}
                </p>
                <Select
                  style={{ width: '50%', padding: '5px' }}
                  size='large'
                  value={code}
                  options={list}
                  onChange={(event) => { _onChange(event, 'code') }}
                  placeholder={t("COMMON:SELECT", { field: t("Temperature Code") })}
                  status={error?.code ? 'error' : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.code}
              </div>
              <div className='mt-2'>
                <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                  {t("DATA_GROUP:LBL_DESCRIPTION")}
                </p>
                <TextArea
                  style={{ width: '50%' }}
                  size='large'
                  value={desc}
                  onChange={(event) => { _onChange(event, 'desc') }}
                  placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_ADDRESS") })}
                  status={error?.description ? 'error' : null}
                />
              </div>
              <div className="text-red-100">
                {err ? err : error?.description}
              </div>
            </Col>
            <Col span={12}></Col>
          </Row>
        </div>
      </div>
      <div className='flex flex-row-reverse gap-[16px] px-5 m-5'>
        <PrimaryButton text={t("USER_DETAIL:SAVE")} action={_onSave} />
        <SecondaryButton action={handleBack} text={t("COMMON:BACK")} />
      </div>
      <ModalSuccessUpdated
        isVisible={visible}
        onOk={handleOk}
      />
      <NotifFailedSaved
        visible={failedModalOpen}
        message={messageFailed}
        action={() => { setFailedModalOpen(false) }}
      />
    </>
  );
}

export default EditTemperature;